import { Divider, Grid, Typography } from "@mui/material";

import styles from "../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/modifyWhatsAppTemplate.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import GlobalButton from "../../../utility/globalButton/button";

function UnsavedChangesPopup({ closeUnsavedChangesModal, confirmSaveAndLeave, confirmLeavePage }: any) {
    return (
        <Grid container direction={"column"} gap={"15px"} className={globalStyles.zIndex1}>
            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`} padding={"0px 30px 0px 30px"}>
                <Typography className={styles.popupTitleStyle}>
                    Unsaved Changes
                </Typography>
            </Grid>

            <Grid item padding={"0 30px 0 30px"}>
                <Divider className={styles.popupDividerStyle} />
            </Grid>

            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`}>
                <Grid container direction={"column"} padding={"0px 30px 5px 30px"} gap={"15px"}>
                    <Grid item>
                        <Typography className={styles.popupBodyTextStyle}>
                        You have unsaved changes. What would you like to do?
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item className={globalStyles.fullwidth} mt={2} padding={"0px 0px 30px 0px"}>
                <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                    <Grid item>
                        <GlobalButton
                            buttonText="Leave without saving"
                            className="borderedButtonStyle"
                            onClick={() => confirmLeavePage()}
                        />
                    </Grid>

                    <Grid item>
                        <GlobalButton
                            buttonText={"Save & leave"}
                            className='borderedButtonStyle' 
                            onClick={() => confirmSaveAndLeave()}
                        />
                    </Grid>

                    <Grid item>
                        <GlobalButton
                            buttonText="Keep Editing"
                            className="primaryButtonStyle"
                            onClick={() => closeUnsavedChangesModal()}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default UnsavedChangesPopup;